export const valueLabelFor = (options, value, texts)=>{
    var _ref;
    var _options_find;
    if (value.length === 0 || value.length === options.length) return texts.all();
    if (value.length === 1) return (_ref = (_options_find = options.find((option)=>option.value === value[0])) === null || _options_find === void 0 ? void 0 : _options_find.label) !== null && _ref !== void 0 ? _ref : value[0];
    return texts.count({
        count: value.length
    });
};
